import { useContext, useState } from 'react';

import Axios from 'axios';
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';

import DashboardContext from '../../Context';

import style from './ModalDelete.module.css';
import { useHistory } from 'react-router-dom';
import toaster from 'helper/toaster';

/**
 * این کامپوننت مدال حذف در جدول است
 */
const ModalDelete = ({
  id,
  urldata,
  showitem,
  handleCloseMoudal,
  handeldeleteModal,
  hasDescription = false,
  isDeactivating = false,
}) => {
  const { location } = useHistory();
  const { urldashboard, authentication } = useContext(DashboardContext);

  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [dataDelete, setDataDelete] = useState({});

  const handelDelete = async () => {
    setLoading(true);
    try {
      const res = hasDescription
        ? await Axios.post(
          `${urldashboard}${urldata ? urldata : location.pathname}/delete`,
          JSON.stringify({ ...formData, workerOrderScheduleId: id }),
          {
            headers: {
              Authorization: authentication,
              'Content-Type': 'application/json',
            },
          }
        )
        : isDeactivating ? await Axios.put(
          `${urldashboard}${urldata ? urldata : location.pathname
          }/deactive`, {
          id
        },
          {
            headers: {
              Authorization: authentication,
              'content-type': 'application/json; charset=utf-8',
            },
          }
        ) :
          await Axios.delete(
            `${urldashboard}${urldata ? urldata : location.pathname
            }/delete/${id}`,
            {
              headers: {
                Authorization: authentication,
                'content-type': 'application/json; charset=utf-8',
              },
            }
          );

      const data = await res.data;

      setDataDelete(data);
      setLoading(false);
      handeldeleteModal();
      toaster.success(data.message);
    } catch (error) {
      if (error.message === 'Network Error') {
        setDataDelete({
          statusCode: 500,
          message: 'اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید:(',
        });
        setLoading(false);
      } else {
        if (isDeactivating) {
          handleCloseMoudal();
          toaster.error(error?.response?.data?.message);
        } else {
          setDataDelete(error?.response?.data);
          setLoading(false);
        }
      }
    }
  };

  const handleChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  return (
    <Modal show={showitem} onHide={handleCloseMoudal}>
      <Modal.Header className={style.Header}>
        <Modal.Title>{isDeactivating ? 'غیرفعالسازی' : 'حذف'} مورد انتخابی</Modal.Title>
        <i
          className='fa fa-times mr-auto'
          style={{ fontSize: '16px', cursor: 'pointer' }}
          onClick={handleCloseMoudal}
          aria-hidden='true'
        ></i>
      </Modal.Header>
      <Modal.Body className={style.body}>
        <i className='mdi mdi-alert-circle-outline'></i>
        {loading
          ? 'درحال حذف منتظر باشید...'
          : dataDelete?.hasOwnProperty('statusCode')
            ? dataDelete?.message
            : isDeactivating ? 'در صورت غیرفعالسازی این قانون، دیگر قادر به فعالسازی آن نمیباشید. آیا اطمینان دارید؟' : 'آیا از حذف مطمئن هستید؟'}
        {hasDescription && (
          <div className='form-group mt-5'>
            <label htmlFor='description'>توضیحات</label>
            <textarea
              rows='6'
              id='description'
              className='form-control'
              onChange={(e) => handleChange('description', e.target.value)}
            ></textarea>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant='danger'
          className='ml-auto'
          disabled={loading}
          onClick={handleCloseMoudal}
        >
          خیر
        </Button>
        <Button variant='success' disabled={loading} onClick={handelDelete}>
          {loading ? <i className='fa fa-spinner fa-pulse fa-fw'></i> : 'بله'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDelete;
